export default __webpack_public_path__ + "assets/pdf/ALT_OS_PatientResultsGuide_Mobile_20240724_NAT-8021619.pdf";